import React from "react";
import "./opensource.css";
import { openSourceData } from "../../data";

export default function OpenSourceComponent() {
  return (
    <section className="section" id="opensource">
      <div className="section-inner">
        <h2 className="section-title">Open Source</h2>
        <span className="section-title-accent" />
        <p className="section-subtitle">
          Contributions to projects and organizations in the open-source community.
        </p>

        <div className="opensource-grid">
          {openSourceData["openSourceData"].map((data, index) => (
            <a
              key={index}
              href={data.repolink}
              target="_blank"
              rel="noreferrer"
              className="opensource-card"
            >
              <img
                src={data.Path}
                alt={data.componyName}
                className="opensource-logo"
              />
              <div className="opensource-body">
                <h3 className="opensource-org">{data.componyName}</h3>
                <p className="opensource-heading">{data.heading}</p>
                <span className="opensource-repo">View repository →</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
